/* Coarse, browser-reported order context. No raw UA, model, identifier or fingerprint is stored. */
(function (scope) {
  'use strict';
  const fields = {
    type: ['Phone', 'Tablet', 'Desktop', 'Unknown'],
    os: ['iOS', 'iPadOS', 'Android', 'Windows', 'macOS', 'ChromeOS', 'Linux', 'Unknown'],
    browser: ['Safari', 'Chrome', 'Chromium', 'Edge', 'Firefox', 'Samsung Internet', 'Opera', 'Android WebView', 'Instagram in-app', 'Facebook in-app', 'Unknown'],
  };
  const cartProperty = '_Added to Cart Device';
  const measurementProperty = '_Face Fit Device';
  function normalize(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
    return Object.fromEntries(Object.entries(fields).map(([key, values]) => [key, values.includes(value[key]) ? value[key] : 'Unknown']));
  }
  function detect(nav = scope.navigator) {
    let type = 'Unknown', os = 'Unknown', browser = 'Unknown';
    try {
      const ua = String(nav?.userAgent || '');
      const hints = nav?.userAgentData;
      const platform = String(hints?.platform || nav?.platform || '');
      const ipad = /iPad/i.test(ua) || (/Macintosh/i.test(ua) && Number(nav?.maxTouchPoints) > 1);
      if (ipad) { type = 'Tablet'; os = 'iPadOS'; }
      else if (/iPhone|iPod/i.test(ua)) { type = 'Phone'; os = 'iOS'; }
      else if (/Android/i.test(ua) || platform === 'Android') { type = /Mobile/i.test(ua) || hints?.mobile === true ? 'Phone' : /Android/i.test(ua) ? 'Tablet' : 'Unknown'; os = 'Android'; }
      else if (/CrOS/i.test(ua) || platform === 'Chrome OS') { type = 'Desktop'; os = 'ChromeOS'; }
      else if (/Windows NT/i.test(ua) || platform === 'Windows') { type = 'Desktop'; os = 'Windows'; }
      else if (/Macintosh|Mac OS X/i.test(ua) || /^(macOS|MacIntel)$/.test(platform)) { type = 'Desktop'; os = 'macOS'; }
      else if (/Linux/i.test(ua) || platform === 'Linux') { type = 'Desktop'; os = 'Linux'; }
      // More-specific browsers must precede their shared Chrome/Safari tokens.
      if (/Instagram/i.test(ua)) browser = 'Instagram in-app';
      else if (/FBAN|FBAV/i.test(ua)) browser = 'Facebook in-app';
      else if (/Edg(?:e|A|iOS)?\//i.test(ua)) browser = 'Edge';
      else if (/SamsungBrowser\//i.test(ua)) browser = 'Samsung Internet';
      else if (/OPR\/|OPiOS\/|Opera\//i.test(ua)) browser = 'Opera';
      else if (/FxiOS\/|Firefox\//i.test(ua)) browser = 'Firefox';
      else if (os === 'Android' && /; wv\)/i.test(ua)) browser = 'Android WebView';
      else if (/CriOS\/|Chrome\//i.test(ua)) browser = 'Chrome';
      else if (/Version\/.+Safari\//i.test(ua)) browser = 'Safari';
      const brands = Array.isArray(hints?.brands) ? hints.brands.map(item => item.brand) : [];
      if (['Unknown', 'Chrome', 'Chromium'].includes(browser)) {
        if (brands.includes('Microsoft Edge')) browser = 'Edge';
        else if (brands.includes('Opera')) browser = 'Opera';
        else if (brands.includes('Google Chrome')) browser = 'Chrome';
        else if (browser === 'Unknown' && brands.includes('Chromium')) browser = 'Chromium';
      }
    } catch { /* Diagnostics must never interrupt measurement or purchase. */ }
    return {type, os, browser};
  }
  function text(value) {
    const context = normalize(value);
    return context ? `${context.type} | ${context.os} | ${context.browser}` : '';
  }
  function cartProperties() { return {[cartProperty]: text(detect())}; }
  function decorateForm(form) {
    Object.entries(cartProperties()).forEach(([name, value]) => form.set(`properties[${name}]`, value));
  }
  // Computers and tablets measure on a phone (owner, 2026-10-18): their cameras see the face small or from the side, so
  // scans there timed out or came out unreliable. A phone asking for the desktop site reports a computer or an iPad but
  // keeps a phone-sized screen (shorter side under 600 px), so it still measures.
  function measuresOnPhone(nav = scope.navigator, screen = scope.screen) {
    const type = detect(nav).type;
    if (type !== 'Desktop' && type !== 'Tablet') return false;
    const shorter = Math.min(Number(screen?.width) || 0, Number(screen?.height) || 0);
    return !(shorter > 0 && shorter < 600);
  }
  scope.SpaceArmoryFitDevice = Object.freeze({detect, normalize, text, cartProperties, decorateForm, measuresOnPhone, cartProperty, measurementProperty});
})(globalThis);
